import { useParams } from 'react-router-dom';

import SeeDetailsPage from 'shared/containers/SeeDetailsPage';
import { GENERAL_INFO_TITLE, SETTINGS_TITLE, ViewDetailsT } from 'shared/containers/ViewDetails/ViewDetails';
import { DeviceProfileT } from 'shared/models/device-profiles';
import SCHCTemplate from 'shared/models/SCHCTemplate';
import api from 'utils/api';

function DeviceProfileItem() {
  const { flowId, deviceProfileId }: any = useParams();

  const dataStructure: ViewDetailsT = {
    sections: [
      {
        title: GENERAL_INFO_TITLE,
        items: [
          {
            type: 'name',
          },
          {
            type: 'creation',
          },
          {
            type: 'update',
          },
        ],
        shape: 2,
      },
      {
        title: SETTINGS_TITLE,
        items: [
          {
            label: 'Template',
            dataPath: 'templateName',
            linkFn: (data: DeviceProfileT) => `/schc-templates/${data.templateId}`,
          },
          {
            label: 'Multicast Enabled',
            dataPath: 'isMulticast',
          },
          {
            label: 'Multicast Address',
            dataPath: 'ipMulticastAddress',
            hideOnEmpty: true,
          },
          {
            label: 'Auto Provisioning',
            dataPath: 'autoProvision',
          },
          {
            label: 'Drop Non-Matching',
            dataPath: 'dropNonMatching',
          },
          {
            label: 'Flush Downlink-Queue',
            dataPath: 'flushDownlinkQueue',
          },
        ],
        shape: 2,
      },
      {
        items: [
          {
            label: 'Template Parameters',
            dataPath: 'templateParameters',
            renderFn: (obj: SCHCTemplate.API.ParametersT, index?: number) => (
              `Index #${index}: ${obj.profileValue}`
            ),
          },
        ],
        shape: 1,
      },
    ],
  };

  return (
    <>
      <SeeDetailsPage
        name="Device Profile"
        targetID={deviceProfileId}
        apiCallParams={{ flowId }}
        fromAPI={api.deviceProfiles}
        defaultURI={`/flows/${flowId}/device-profiles`}
        dataStructure={dataStructure}
        useDeleteEnforceConfirm
      />
    </>
  );
}

export default DeviceProfileItem;
